import { render } from "./VisionTag.vue?vue&type=template&id=d3f99c68&scoped=true"
import script from "./VisionTag.vue?vue&type=script&lang=js"
export * from "./VisionTag.vue?vue&type=script&lang=js"

import "./VisionTag.vue?vue&type=style&index=0&id=d3f99c68&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f99c68"]])

export default __exports__